import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import {
  Link
} from '../'
import Styles from './Works.css'

@CSSModules(Styles)
export default class Works extends Component {
  static propTypes = {
  }
  constructor(props){
    super(props);
  }
  render() {
    const iconOne   = require('../../../static/images/icons_step1_purple.svg')
    const iconTwo   = require('../../../static/images/icons_step2_purple.svg')
    const iconThree = require('../../../static/images/icons_step3_purple.svg')
    const iconFour  = require('../../../static/images/icons_step4_purple.svg')

    return (
      <div styleName='works-wrap'>
        <div styleName='works'>
          <div styleName='works-inner'>
            <div styleName='works-title'>
              Align your investments with<br/>your <span styleName='primary'>social justice values</span>
            </div>
            <div styleName='works-steps-photos'>
              <div styleName='works-steps'>
                <div styleName='works-step'>
                  <img
                    styleName='works-step-img'
                    alt='Step one icon'
                    src={iconOne}
                  />
                  <div styleName='works-step-title'>1</div>
                  <div styleName='works-step-info'>
                    <span styleName='white'>
                      <Link
                        to={config.routes.clean}
                        title='Search funds'
                        strong
                      >
                        Search for mutual funds and exchange-traded funds
                        (ETFs)
                      </Link>
                    </span> by name, ticker, or asset manager. Our database
                    covers thousands of funds available in the U.S.
                  </div>
                </div>
                <div styleName='works-step'>
                  <img
                    styleName='works-step-img'
                    alt='Step two icon'
                    src={iconFour}
                  />
                  <div styleName='works-step-title'>2</div>
                  <div styleName='works-step-info'>
                    See your results. For each fund, we use the list of fund
                    holdings to calculate scores for
                    gender equality, diversity disclosures, racial justice,
                    and LGBTQ+ equity.
                    Then, we rank funds against others with a similar
                    investment profile, and apply grades
                    based on those group rankings.
                  </div>
                </div>
                <div styleName='works-step'>
                  <img
                    styleName='works-step-img'
                    alt='Step three icon'
                    src={iconTwo}
                  />
                  <div styleName='works-step-title'>3</div>
                  <div styleName='works-step-info'>
                    <span styleName='white'>
                      <Link
                        to={config.routes.clean}
                        title='Search funds'
                        strong
                      >
                        Look for options that align with your values.
                      </Link>
                    </span> Sort and compare to find funds that fit your
                    investing needs.
                  </div>
                </div>
                <div styleName='works-step'>
                  <img
                    styleName='works-step-img'
                    alt='Step four icon'
                    src={iconThree}
                  />
                  <div styleName='works-step-title'>4</div>
                  <div styleName='works-step-info'>
                    <span styleName='white'>
                      <Link
                        to={config.routes.toolkit}
                        title='Action toolkit'
                        strong
                      >
                        Talk to your financial advisor or retirement plan
                        manager
                      </Link>
                    </span> about investing with a social justice lens.
                  </div>
                </div>
              </div>
              { /* <div
                styleName='works-photo'
                title='How to align your investments align with your social justice values'
              /> */ }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

